export default {
      id: "generator-powel-grid-usage",
      viewBox: "0 0 59 55",
      url: __webpack_public_path__ + "img/icons.svg#generator-powel-grid",
      toString: function () {
        return this.url;
      }
    }